module.exports = __webpack_public_path__ + "fonts/gothica1-semibold-webfont.9669cfd.woff2";